(() => {
  document.querySelectorAll('.shop-the-look').forEach((section) => {
    const card = section.querySelector('[data-stl-card]');
    if (!card) return;
    const img = card.querySelector('[data-stl-img]');
    const title = card.querySelector('[data-stl-title]');
    const price = card.querySelector('[data-stl-price]');
    const addBtn = card.querySelector('[data-stl-add]');
    let variantId = null, adding = false;
    section.querySelectorAll('[data-hotspot]').forEach((hotspot) => {
      hotspot.addEventListener('click', () => {
        variantId = hotspot.getAttribute('data-variant-id');
        img.src = hotspot.getAttribute('data-image') || '';
        img.alt = hotspot.getAttribute('data-title') || '';
        title.textContent = hotspot.getAttribute('data-title') || '';
        const p = hotspot.getAttribute('data-price') || '';
        const c = hotspot.getAttribute('data-compare');
        price.innerHTML = c ? '<s>' + c + '</s> ' + p : p;
        addBtn.disabled = false; addBtn.textContent = 'ADD';
        card.hidden = false;
      });
    });
    card.querySelector('[data-stl-close]').addEventListener('click', () => { card.hidden = true; });
    addBtn.addEventListener('click', () => {
      if (!variantId || adding) return;
      adding = true; addBtn.disabled = true; addBtn.textContent = 'ADDING...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }) })
        .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
        
        .then((parsedState) => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && parsedState.sections) drawer.renderContents(parsedState);
          
          addBtn.textContent = 'ADDED 2713';
          setTimeout(() => { card.hidden = true; }, 1200);
        })
        .catch(() => { addBtn.textContent = 'TRY AGAIN'; addBtn.disabled = false; })
        .finally(() => { adding = false; });
    });
  });
})();
